<template>
  <nav>
    <div class="pagination">
      <div class="my-2">
        <button :disabled="currentPage == 1" @click="controls(-1)">
          <v-icon v-if="$vuetify.breakpoint.smAndDown">mdi-chevron-left</v-icon>
          <span v-if="!$vuetify.breakpoint.smAndDown">Anterior</span>
        </button>
        <button
          v-for="(page, index) in pagesToShow"
          :key="index"
          @click="changePage(page)"
          :class="{ active: page === value, 'page-number': true }"
        >
          {{ page }}
        </button>
        <button :disabled="currentPage === totalPages" @click="controls(1)">
          <v-icon v-if="$vuetify.breakpoint.smAndDown">mdi-chevron-right</v-icon>
          <span v-if="!$vuetify.breakpoint.smAndDown">Siguiente</span>
        </button>
      </div>
      <v-select v-model="perPageSelected" :items="perPageOptions" @input="selectOption" dense outlined hide-details
        class="per-page-selector my-2" :menu-props="{ bottom: true, offsetY: true }"></v-select>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    
  },
  emits: ["update:modelValue", "perPageChange", 'page-changed', 'change'],
  data() {
    return {
      perPageSelected: this.perPage,
      openSelect: false,
      totalVisible: 3,
      perPageOptions: [5, 10, 20, 50, 100],
      perPageSelected: 10,
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.value;
      },
      set(newPage) {
        this.$emit("input", newPage);
      },
    },
    pagesToShow() {
      const currentPage = this.value;
      const total = this.totalPages;
      const totalVisible = this.totalVisible;
      const halfVisible = Math.floor(totalVisible / 2);
      let from = currentPage - halfVisible;
      let to = currentPage + halfVisible;

      // Asegurar que las páginas mostradas estén dentro del rango válido
      if (from < 1) {
        from = 1;
        to = Math.min(totalVisible, total);
      }
      if (to > total) {
        to = total;
        from = Math.max(1, total - totalVisible + 1);
      }

      // Crear un array con las páginas que se mostrarán

      const pages = [];
      if (from > 1) {
        pages.push(1);
        if (from > 2) {
          pages.push("..."); // Agregar puntos suspensivos al principio o al final
        }
      }
      for (let i = from; i <= to; i++) {
        pages.push(i);
      }
      if (to < total) {
        if (to < total - 1) {
          pages.push("..."); // Agregar puntos suspensivos  al final
        }
        pages.push(total);
      }
      return pages;
    },
  },
  watch: {
    value(newValue, oldValue) {
      this.$emit("change", newValue, oldValue);
    },
    perPage: {
      immediate: true,
      handler(newValue) {
        if (newValue && this.perPageOptions.includes(newValue)) {
          this.perPageSelected = newValue;
        }
      },
    },
  },
  mounted() {
    document.addEventListener("click", this.clickOutside);
    window.addEventListener("scroll", this.handleMove);
    window.addEventListener("resize", this.handleMove);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.clickOutside);
    window.removeEventListener("scroll", this.handleMove);
    window.removeEventListener("resize", this.handleMove);
  },
  methods: {
    toggleSelect() {
      this.openSelect = !this.openSelect;

      this.$nextTick(() => {
        if (this.openSelect) this.positionDropdown();
      });
    },

    /** REPOSICIONA cuando se mueve la pantalla */
    handleMove() {
      if (this.openSelect) this.positionDropdown();
    },

    /** Posición del menú */
    positionDropdown() {
      if (!this.$refs.selectRef) return;
      if (!this.$refs.optionsRef) return;
      const display = this.$refs.selectRef.querySelector(".select-display");
      if (!display) return;

      const menu = this.$refs.optionsRef;
      const rect = display.getBoundingClientRect();

      menu.style.position = "fixed";
      menu.style.top = rect.bottom + 4 + "px";
      menu.style.left = rect.left + "px";
      menu.style.width = rect.width + "px";
      menu.style.zIndex = 999999;
    },

    clickOutside(e) {
      if (!this.openSelect) return;
      if (!this.$refs.selectRef) return;

      if (!this.$refs.selectRef.contains(e.target)) {
        this.openSelect = false;
      }
    },

    selectOption(opt) {
      this.perPageSelected = opt;
      this.openSelect = false;

      this.$emit("perPageChange", opt);
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.$emit("page-changed", page);
      }
    },
    controls(variable) {
      this.currentPage = this.currentPage + variable;
      this.$emit("page-changed", this.currentPage);
    },
    changePerPage() {
      this.$emit("perPageChange", this.perPageSelected);
    },
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  /* padding: 15px 10px; */
}

.pagination button {
  color: black;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 3px 8px;
  margin: 0 5px;
}

.pagination button.page-number {
  border-radius: 25px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: white;
  padding: 3px 8px;
  min-width: 25px;
}

.pagination button.page-number:hover:not(.active) {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 25px;
}

.pagination button:hover {
  background-color: #1C1E4D;
  color: #fff;
  border-radius: 25px;
}

.pagination button:hover .v-icon {
  color: #fff;
  transition: none;
}

.pagination button.active {
  background-color: #1C1E4D;
  border-radius: 25px !important;
  color: #fff;
}

/* Select */
.custom-select {
  position: relative;
  margin-left: 15px;
  width: 85px !important;
  user-select: none;
}

.select-display {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 5px;
  background: white;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.select-display:hover {
  border-color: #1C1E4D;
}

.select-display.focused {
  border-color: #1C1E4D;
  box-shadow: 0 0 0 1px rgba(28, 30, 77, 0.25);
}

.options {
  position: fixed;
  background: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  list-style: none;
  padding: 5px 0;
  margin: 0;
  z-index: 999999;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  max-height: 200px;
  overflow-y: auto;
}

.options li {
  padding: 6px 10px;
  cursor: pointer;
}

.options li.selected {
  background-color: #DADBE2;
}

</style>
